import {Empty} from '@baidu/qianfan-antd-kit';
import {useEffect} from 'react';
import {useLocation, useNavigate} from 'react-router';
import {SCIndexContainer} from '@/styles/modules';

const NoFoundMap: any = {
    '/qualify/company': '/qualify/choices/company',
    '/qualify/person': '/qualify/choices/person',
    '/': '/qualify/index',
};

const NoMatch = () => {
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(
        () => {
            if (NoFoundMap[location.pathname]) {
                return navigate(`${NoFoundMap[location.pathname]}${location.search}`);
            }
        },
        [location, navigate]
    );

    return (
        <SCIndexContainer>
            <Empty description="404：找不到页面" />
        </SCIndexContainer>
    );
};

export default NoMatch;
